import React, { useMemo } from "react";
import { Panel } from "@shared/components/Panel";
import { Patient } from "@shared/models";
import { PatientCardStablePeriodInfo } from "@containers/Patient/components/PatientDetailsContainer/PatientCardStablePeriodInfo";
import "./index.scss";

export interface PatientStablePeriodDetailsProps {
  patient: Patient;
}

const PatientStablePeriodDetails: React.FC<PatientStablePeriodDetailsProps> = (props) => {
  const { patient } = props;

  const stablePeriodRRValue = useMemo(() => {
    return patient.patient_settings?.rr_stable_period || 0;
  }, [patient]);

  const stablePeriodHRValue = useMemo(() => {
    return patient.patient_settings?.hr_stable_period || 0;
  }, [patient]);

  const stablePeriodRRAvgValue = useMemo(() => {
    return patient.patient_settings?.rr_current_avg || 0;
  }, [patient]);

  const stablePeriodHRAvgValue = useMemo(() => {
    return patient.patient_settings?.hr_current_avg || 0;
  }, [patient]);

  const stablePeriodRRPercentage = useMemo(() => {
    if (!stablePeriodRRValue || (!stablePeriodRRAvgValue && stablePeriodRRValue !== stablePeriodRRAvgValue)) return 0;
    if (stablePeriodRRValue === stablePeriodRRAvgValue) return 0;
    if (stablePeriodRRValue > stablePeriodRRAvgValue) {
      const percentage = 100 - (stablePeriodRRAvgValue / stablePeriodRRValue) * 100;
      return Number(percentage.toFixed(2));
    }

    const percentage = 100 - (stablePeriodRRValue / stablePeriodRRAvgValue) * 100;
    return Number(percentage.toFixed(2));
  }, [stablePeriodRRValue, stablePeriodRRAvgValue]);

  const stablePeriodHRPercentage = useMemo(() => {
    if (!stablePeriodHRValue || (!stablePeriodHRAvgValue && stablePeriodHRValue !== stablePeriodHRAvgValue)) return 0;
    if (stablePeriodHRValue === stablePeriodHRAvgValue) return 0;
    if (stablePeriodHRValue > stablePeriodHRAvgValue) {
      const percentage = 100 - (stablePeriodHRAvgValue / stablePeriodHRValue) * 100;
      return Number(percentage.toFixed(2));
    }

    const percentage = 100 - (stablePeriodHRValue / stablePeriodHRAvgValue) * 100;
    return Number(percentage.toFixed(2));
  }, [stablePeriodHRValue, stablePeriodHRAvgValue]);

  return (
    <Panel className="patient-stable-details-panel">
      <div className="patient-stable-details-content">
        <PatientCardStablePeriodInfo
          signalName="HR"
          stablePeriod={stablePeriodHRValue}
          stableAvgPeriod={stablePeriodHRAvgValue}
          stablePeriodPercentage={stablePeriodHRPercentage}
        />
        <PatientCardStablePeriodInfo
          signalName="RR"
          stablePeriod={stablePeriodRRValue}
          stableAvgPeriod={stablePeriodRRAvgValue}
          stablePeriodPercentage={stablePeriodRRPercentage}
        />
      </div>
    </Panel>
  );
};

export default PatientStablePeriodDetails;
